module.exports = __webpack_public_path__ + "static/dash-5-6e14ec55c9bd07c4e9a0b67d9e18c8e1.png";